const safeNum = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
};

const getRowMetric = (row, keys) => {
    for (const key of keys) {
        if (row?.[key] != null && row?.[key] !== '') return safeNum(row[key]);
    }
    return 0;
};

const sumCampaignRows = (rows) => {
    const list = Array.isArray(rows) ? rows : [];
    return list.reduce((acc, row) => {
        acc.impressions += getRowMetric(row, ['IMPRESSIONS', 'impressions']);
        acc.clicks += getRowMetric(row, ['CLICKS', 'clicks']);
        acc.conversions += getRowMetric(row, ['CONVERSIONS', 'conversions']);
        acc.cost += getRowMetric(row, ['COST', 'cost']);
        acc.revenue += getRowMetric(row, ['REVENUE', 'revenue']);
        return acc;
    }, {
        impressions: 0,
        clicks: 0,
        conversions: 0,
        cost: 0,
        revenue: 0
    });
};

const resolveCount = (metric, fallback) => {
    const metricCount = safeNum(metric?.count);
    if (metric?.count == null) return fallback;
    if (fallback > 0 && metricCount <= 0) return fallback;
    return metricCount;
};

const buildMetric = (metric, count) => ({
    ...(metric || {}),
    count: safeNum(count)
});

const buildDerivedStats = (stats, totals) => {
    const impressions = resolveCount(stats?.impressions, totals.impressions);
    const clicks = resolveCount(stats?.clicks, totals.clicks);
    const conversions = resolveCount(stats?.conversions, totals.conversions);
    const cost = resolveCount(stats?.cost, totals.cost);
    const revenue = resolveCount(stats?.revenue, totals.revenue);
    const ctr = impressions ? (clicks / impressions) * 100 : 0;
    const convrate = clicks ? (conversions / clicks) * 100 : 0;
    const cpc = clicks ? cost / clicks : 0;
    const cpm = impressions ? (cost / impressions) * 1000 : 0;
    const avgGift = conversions ? revenue / conversions : 0;
    const roas = cost ? revenue / cost : 0;

    return {
        impressions: buildMetric(stats?.impressions, impressions),
        clicks: buildMetric(stats?.clicks, clicks),
        conversions: buildMetric(stats?.conversions, conversions),
        cost: buildMetric(stats?.cost, cost),
        revenue: buildMetric(stats?.revenue, revenue),
        ctr: buildMetric(stats?.ctr, ctr),
        convrate: buildMetric(stats?.convrate, convrate),
        cpc: buildMetric(stats?.cpc, cpc),
        cpm: buildMetric(stats?.cpm, cpm),
        avgGift: buildMetric(stats?.avgGift, avgGift),
        roas: buildMetric(stats?.roas, roas)
    };
};

export const buildChannelMetricBundle = ({
    channel,
    previousChannel,
    campaignRows,
    previousCampaignRows
}) => {
    const currentTotals = sumCampaignRows(campaignRows);
    const previousTotals = sumCampaignRows(previousCampaignRows);
    const currentStats = buildDerivedStats(channel?.stats, currentTotals);
    const previousStats = buildDerivedStats(previousChannel?.stats, previousTotals);

    return {
        currentStats,
        previousStats
    };
};

